import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  PlanInfoContainerStyled,
  ElectionTitleWrapperStyled,
  PremiumWrapperStyled,
  CarrierNameStyled,
  PremiumPerPayTextStyled,
} from '../../CoverageCardStyled';
import { selectPerPayPeriodText } from 'enrollment/services';
import { BenefitDto, CoverageDto } from 'theSource/queries';
import { getPremiumStyled, RETURN_VALUE_ONLY } from 'enrollment/utils';
import { showRiderDetails as showRiderDetailsFunc } from 'enrollment/features/Benefits/BenefitsPreview/GroupedBenefits/utils';
import { CategoryCoverageDto } from 'enrollment/queries/useBenefitCategoryQuery/types';

interface PlanInfoProps {
  planName: string;
  carrierName: string;
  subscriberPremium: number;
  volume?: number;
  isVolumeBenefit?: boolean;
  coverage?: CoverageDto;
  benefitDetails?: BenefitDto;
}

export const PlanInfo = ({
  planName,
  carrierName,
  subscriberPremium,
  volume,
  isVolumeBenefit = false,
  coverage,
  benefitDetails,
}: PlanInfoProps) => {
  const { t } = useTranslation('common');

  const perPayText = useSelector(selectPerPayPeriodText);

  let riderPremium = 0;
  coverage?.rider_coverages?.forEach((riderCov) => {
    riderPremium += Number(riderCov.req_subscriber_premium);
  });
  coverage?.coverage_lines?.forEach((line) => {
    line.rider_coverage_lines?.forEach((riderCov) => {
      riderPremium += Number(riderCov.req_subscriber_premium);
    });
  });

  const formattedSubscriberPremium = getPremiumStyled({
    premium: String(Number(subscriberPremium) + riderPremium || 0),
    valueOnly: RETURN_VALUE_ONLY,
  });
  const formattedVolume = getPremiumStyled({
    premium: String(Number(volume) || 0),
    valueOnly: RETURN_VALUE_ONLY,
  });

  const showRiderDetails = showRiderDetailsFunc(
    coverage as unknown as CategoryCoverageDto
  );
  const ridersLength =
    coverage?.rider_coverages?.length ||
    coverage?.coverage_lines?.reduce((acc, line) => {
      acc += line.rider_coverage_lines?.length || 0;
      return acc;
    }, 0) ||
    0;

  const isDevice = window.innerWidth < 1024;
  const isScreenSmall = window.innerWidth < 744;
  return (
    <>
      <PlanInfoContainerStyled>
        <ElectionTitleWrapperStyled>
          <h3 className="mb-0">
            {planName.trim().length > 17 && isDevice
              ? `${planName.slice(0, 17)}...`
              : planName}
          </h3>
          <CarrierNameStyled className="mb-0">{carrierName}</CarrierNameStyled>
          {isVolumeBenefit &&
            !isScreenSmall &&
            !benefitDetails?.hide_volume_on_confirm && (
              <div className="mt-2">
                <p>{`Coverage Amount: ${formattedVolume}`}</p>
              </div>
            )}
        </ElectionTitleWrapperStyled>
        <PremiumWrapperStyled>
          {typeof formattedSubscriberPremium === 'string' &&
            (!benefitDetails?.hide_cost_if_empty ||
              Number(subscriberPremium) + riderPremium > 0) && (
              <>
                <h3 className="mb-0">{formattedSubscriberPremium}</h3>
                {!isScreenSmall && (
                  <PremiumPerPayTextStyled className="mb-0">{`${perPayText}`}</PremiumPerPayTextStyled>
                )}
              </>
            )}
          {showRiderDetails && (
            <p className="body2 mb-0">
              (
              {t('enrollment.riderMyBenefitsLink', {
                value: ridersLength,
              })}
              )
            </p>
          )}
        </PremiumWrapperStyled>
      </PlanInfoContainerStyled>
    </>
  );
};
